<template>
  <SharedPagesWorksSlugComponent
    :pageData="data"
    :parentPageData="parentData"
    :parentRoute="{ name: 'program-slug', params: { slug: slugFromRoute } }"
    routeName="program-slug-secondaryslug"
  />
</template>

<script setup>
// 1
defineI18nRoute({
  paths: {
    en: '/programme/[slug]/[secondary-slug]',
    nl: '/programma/[slug]/[secondary-slug]'
  }
})

const route = useRoute()
const { locale: currentLocale } = useI18n()
const { slug: slugFromRoute, secondaryslug: secondarySlugFromRoute } = route.params

// 1
const queryPath = queryWorkEntryBySlug({ slug: secondarySlugFromRoute, locale: currentLocale.value })
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPath } }
  )
})

if (!data?.value?.data?.length || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)

// 2
const { data: parentData, error: parentError } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryProgramEntryBySlug({ slug: slugFromRoute }) } }
  )
})
</script>
